import { ColumnDef } from "@tanstack/react-table"

import { PaymentHistoryType } from "@/types/payment"
import { formatDateAndTime } from "@/lib/utils"

import { DataTableColumnHeader } from "../../data-table"

export const paymentHistoryColumns: ColumnDef<PaymentHistoryType>[] = [
  {
    accessorKey: "payment_id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Payment ID" />
    ),
    cell: ({ row }) => {
      const value = row.original.payment_id
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "consumer_name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    cell: ({ row }) => {
      const value = row.original.consumer_name
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "consumer_billing_id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Billing ID" />
    ),
    cell: ({ row }) => {
      const value = row.original.consumer_billing_id
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "amount_paid",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Amount Paid" />
    ),
    cell: ({ row }) => {
      const value = row.original.amount_paid
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "or_num",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Or Num" />
    ),
    cell: ({ row }) => {
      const value = row.original.or_num
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "payment_date",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Payment Date" />
    ),
    cell: ({ row }) => {
      const value = row.original.payment_date
      return <div>{formatDateAndTime(value)}</div>
    },
  },
]
